import type { TripUpdate } from '@/@types/trip-updates';
import { StopType } from '@/@types/trip-updates';
import { tripUpdateOnServiceDate } from '@/libs/journey/realtime';

/**
 * The trip updates with a REUSE stop, kept on the service date of their trip that day and
 * dated to it: the lib only matches `date`, info honours `end_date`. Every one is kept, even
 * when none of its REUSE stops is requested: the lib takes the ends of the deviated trip
 * (pysae/transit-core#7). `undefined` when none applies, so that the lib keeps the trips as they are.
 */
export function reuseUpdatesFor(
  tripUpdates: ReadonlyArray<TripUpdate>,
  tripsOfDay: { readonly [tripId: string]: { service_date: string } },
): Array<TripUpdate> | undefined {
  const updates = tripUpdates.reduce((acc, tripUpdate) => {
    const serviceDate = tripsOfDay[tripUpdate.trip_id]?.service_date;
    const reusesStop = tripUpdate.temporary_stops?.some(stop => stop.type === StopType.REUSE);
    if (serviceDate && reusesStop && tripUpdateOnServiceDate(tripUpdate, serviceDate)) {
      acc.push({ ...tripUpdate, date: serviceDate });
    }
    return acc;
  }, [] as Array<TripUpdate>);
  return updates.length > 0 ? updates : undefined;
}
